import { zodResolver } from "@hookform/resolvers/zod";
import { Box, Typography, Grid, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import FormFields from "./fields.json";
import DynamicForm from "../common/DynamicForm";
import { passcodeSchema } from "../../config/schemas/forgotPasscodeSchema";
import "./../../theme.scss";
import "../../assets/styles/common-styles.scss";
import { usePasscode } from "../../hooks/usePasscode";
import { useSnackbar } from "../../hooks/useSnackbar";
import { useNavigate } from "react-router-dom";
import Loader from "../common/Loader/Loader";
import { useAppDispatch } from "../../store";
import { showLoader, hideLoader } from "../../store/slices/loaderSlice";

const GetPasscode: React.FunctionComponent<any> = (props) => {
  const { setIsEmailPresent } = props;
  const dispatch = useAppDispatch();
  const { showSuccess, handleError } = useSnackbar();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  type FormValues = z.infer<typeof passcodeSchema>;
  const {
    getPasscode,
    passcodeData,
    passcodeIsError,
    passcodeError,
    passcodeIsLoading,
    passcodeIsSuccess,
  } = usePasscode();
  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useForm<FormValues>({
    resolver: zodResolver(passcodeSchema),
    defaultValues: {
      email: "",
    },
  });
  const submit = (data: FormValues) => {
    setEmail(data?.email);
    getPasscode({ email: data?.email });
  };
  const onInvalid = (errors: any) => console.debug(errors);

  const handleBack = () => {
    reset();
    localStorage.removeItem("passcodeEmail");
    setIsEmailPresent(false);
    navigate("/login");
  };

  useEffect(() => {
    if (passcodeIsSuccess) {
      const successMsg = passcodeData;
      showSuccess(successMsg?.details, "get-passcode-success");
      if (email) {
        localStorage.setItem("passcodeEmail", email);
        setIsEmailPresent(true);
      }
    }
  }, [passcodeIsSuccess]);

  useEffect(() => {
    if (passcodeIsError) {
      const error: any = passcodeError;
      handleError(error);
    }
  }, [passcodeIsError]);

  useEffect(() => {
    if (passcodeIsLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [passcodeIsLoading]);

  return (
    <>
      <Box sx={{ mt: 3 }}>
        <Loader />
        <Typography paragraph gutterBottom>
          A one-time passcode will be sent to the following address:
        </Typography>
        <form onSubmit={handleSubmit(submit, onInvalid)}>
          <DynamicForm
            fieldsJson={FormFields?.passcodeFields}
            errors={errors}
            register={register}
            control={control}
          />
          <p className="mt4 pb3">&nbsp;</p>
          <Typography paragraph className="mt4">
            Enter the passcode on the next step.
            <br />
            Note: your passcode will be{" "}
            <strong>valid for only 20 minutes</strong>.
          </Typography>
          <Grid container alignItems="center" className="mt4">
            <Grid item xs>
              <Button variant="outlined" id="backReset" onClick={handleBack}>
                Back
              </Button>
            </Grid>
            <Grid item>
              <Button type="submit" variant="contained" id="getPWC">
                Get Passcode
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </>
  );
};

export default GetPasscode;
